import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonES from '../locales/es-MX/common.json';

i18n.use(initReactI18next).init({
  resources: {
    'es-MX': { common: commonES },
  },
  lng: 'es-MX',
  fallbackLng: 'es-MX',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

/**
 * Backward-compatible t() export.
 * Existing code importing { t } from '@/lib/i18n' continues to work.
 */
export const t = i18n.t.bind(i18n);
export const setLocale = (locale: string) => i18n.changeLanguage(locale);
export const getLocale = () => i18n.language;

export default i18n;
